
/**
 * 
 * @param { data obj returned from payments/verify api} data 
 * @param { name of the additonal cost to be applied eg: paypal-transaction-fee } keyName 
 */
export const getAdditionalCost = (data, keyName) => data.reduce((acc, obj) => {
  if (obj.name === keyName) {
      acc = obj.amount;
  };
  return acc;
}, null);




// WEBPACK FOOTER //
// ./src/screens/Flights/Review/utils.js